import { gql } from '@apollo/client';

export const JOIN_THE_CLUB_MUTATION = gql`
  mutation JoinTheClub($input: JoinTheClubInput!) {
    joinTheClub(input: $input)
  }
`;
